export const sortByOrder = <T extends {order?: number | null}>(array: T[] | undefined | null): T[] => {
  if (!Array.isArray(array)) {
    return [];
  }
  if (array.length === 0) {
    return [];
  }
  return [...array].sort((a, b) => {
    const hasOrderA = a?.order !== undefined && a?.order !== null;
    const hasOrderB = b?.order !== undefined && b?.order !== null;

    if (hasOrderA && hasOrderB) {
      return a.order! - b.order!;
    }
    if (hasOrderA && !hasOrderB) {
      return -1;
    }
    if (!hasOrderA && hasOrderB) {
      return 1;
    }
    return 0;
  });
};
